import Badge from './Badge';
import Base from '../base';

/* istanbul ignore next */
Badge.install = function (Vue) {
  Vue.use(Base);
  Vue.component(Badge.name, Badge);
};

export default Badge;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/badge/index.js
// module id = null
// module chunks = 